import React from "react";
import { Grid } from "@mui/material";
import LabeledSelect from "../../Widgets/LabeledSelect";
import { TraumaHistoryFormValues } from "./interface";

interface EditFieldsProps {
  formValues: TraumaHistoryFormValues;
  handleChange: (
    field: keyof TraumaHistoryFormValues
  ) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export const EditFields: React.FC<EditFieldsProps> = ({ formValues, handleChange }) => {
  return (
    <Grid container spacing={7}>
      <LabeledSelect
        label="Does the client have a history of trauma?"
        value={formValues.hasTraumaHistory}
        onChange={handleChange("hasTraumaHistory")}
        options={[
          { label: "Yes", value: "YES" },
          { label: "No", value: "NO" },
        ]}
      />
    </Grid>
  );
};

export default EditFields;
